import { useQuery } from '@apollo/client';
import { QUERY_SUBSCRIPTIONS } from '../../../graphql/subscription';
import SubscriptionCard from './SubscriptionCard';

export function Subscription ({id}) {

    const query = useQuery(QUERY_SUBSCRIPTIONS, {
        variables: {
            filters: {
                user: {
                    id: {
                        eq: id
                    }
                }
            },
            pagination: {
                limit: 1
            },
            sort: ['createdAt:DESC'],
        },
    });

    if (query.data?.subscriptions?.data?.length > 0) {
        return <SubscriptionCard id={query.data?.subscriptions?.data[0].id} data={query.data?.subscriptions?.data[0]} />
    } else {
        return null
    }
}